
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[membershipSlug]",
      function () {
        return require("private-next-pages/m/[membershipSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[membershipSlug]"])
      });
    }
  